module.exports = __webpack_public_path__ + "assets/img/index-partner34.0c9fcfef.jpg";